common.View.create('shop::Habitats.Website.Modules.ShopProducts.Index.Products', {

    onDOMLoad()
    {
        this.initSorting();
        this.initScrollButton();
    },

    initScrollButton()
    {
        $(window).scroll(() => {
            // Show scroll button?
            if ($(window).scrollTop() > 500) {
                this.element.find('.scroll-button').fadeIn('fast');
            } else {
                this.element.find('.scroll-button').fadeOut('fast');
            }
        });

        this.element.find('.scroll-button').click((e) => {

            // Scroll to top with animation
            $('html, body').animate({
                scrollTop: $('.shop\\:\\:Habitats-Website-Modules-ShopProducts-Index-Products').offset().top - 100
            }, 500);

            e.preventDefault();
        });
    },

    initSorting()
    {
        this.element

            // Listen for sort change.
            .find('select[name="sort"]')
                .change(() => this.getIndexInstance().onUserInput())
                .end();
    },

    getIndexInstance()
    {
        return shop.Habitats.Website.Modules.ShopProducts.Index.getInstance(this);
    },

    getSortQuery()
    {
        // Get sort value.
        let sortElement = this.element.find('select[name="sort"]');
        let sortValue = sortElement.val();

        // Is custom sort?
        if(sortElement.find('option:first').val() != sortValue)
            return {
                sort: sortValue,
            };

        // Is default sort? No need to be in the url.
        else
            return {};
    },

    setLoading()
    {
        this.element.addClass('loading');
    },

    updateHtml(ajaxResponse)
    {
        // Replace HTML.
        this.element.replaceWith(ajaxResponse.find('.shop\\:\\:Habitats-Website-Modules-ShopProducts-Index-Products'));

        //
        common.View.reinit();
    },

});
